import CustomModal from "../Common/CustomModal";
import { ExclamationTriangleIcon } from "../../assets/icons";
import "./style.css";

const CustomWarningModal = ({ isOpen, text, onClose }) => {
  return (
    <CustomModal title="Warning" isVisible={isOpen} onClose={onClose}>
      <div className="warning-modal-body">
        <p className="warning-modal-icon">
          <ExclamationTriangleIcon className="size-6" />
        </p>
        <p className="warning-modal-text">{text}</p>
      </div>
    </CustomModal>
  );
};

export default CustomWarningModal;
